import {
  PageContainer,
  PageNotFound,
} from '@leagueplatform/web-common-components';
import { useDocumentTitle } from '@leagueplatform/web-common';
import { Masonry } from '@leagueplatform/masonry';
import { MASONRY_V2 } from 'common/constants';
import { useGetAppInitDetails } from 'hooks/use-get-app-init-details';
import { LoadingSpinner } from 'components/spinner/loading-spinner.component';

export const EnhancedBenefitsPage = () => {
  useDocumentTitle('Enhanced Benefits');

  const { isLoading, isEnhancedMember } = useGetAppInitDetails();
  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!isEnhancedMember) {
    return <PageNotFound />;
  }

  return (
    <PageContainer>
      <Masonry rootNodeId={MASONRY_V2.ROOT_ENHANCED_BENEFITS} />
    </PageContainer>
  );
};
